import React from "react";
import {Tabs} from "antd";
import {connect} from "react-redux";
import {TabsType} from "antd/lib/tabs";
import {TabPosition} from "rc-tabs/lib/interface";
import {getTranslate, Translate, TranslateFunction} from "react-localize-redux";
import {FilterType, ContentType} from "../../enums/enums";
import StoreState from "../../interfaces/store/storeState";
import "./QualificationsView.scss";
import CardList from "../../components/CardList/CardList";
import {setActiveTestType} from "../../store/actions/test";
import {SetActiveTestTypeAction} from "../../interfaces/store/test";
import {
    DestroyDetailsDrawerAction,
    GetPhaseConfigListAction,
    SetFilterTypeAction,
    SetJobTestTypeAction,
    SetSelectedFiltersAction,
    SetFiltersDrawerVisibilityAction,
} from "../../interfaces/store/actions/job";
import {
    destroyDetailsDrawer, getPhaseConfigList, setFilterType, setSelectedFilters, setJobTestType, setFiltersDrawerVisibility,
} from "../../store/actions/job";
import {SelectedFiltersData} from "../../interfaces/store/actions/payload/job";

const {TabPane}: typeof Tabs = Tabs;

interface StateProps {
    isMobile: boolean
    activeTestType: string
    translate: TranslateFunction
}
interface DispatchProps {
    setActiveTestType(payload: string): SetActiveTestTypeAction

    setFilterType(payload: string): SetFilterTypeAction

    getPhaseConfigList(): GetPhaseConfigListAction

    setSelectedFilters(payload: SelectedFiltersData): SetSelectedFiltersAction

    destroyDetailsDrawer(): DestroyDetailsDrawerAction

    setFiltersDrawerVisibility(payload: boolean): SetFiltersDrawerVisibilityAction

    setJobTestType(payload: boolean): SetJobTestTypeAction
}

type Props = StateProps & DispatchProps;

class QualificationsView extends React.Component<Props> {
    private static readonly translationPath: string = "pages.QualificationsView.QualificationsView";

    constructor(props: Props) {
        super(props);

        this.onChangeHandler = this.onChangeHandler.bind(this);

        this.getTabPanes = this.getTabPanes.bind(this);
    }

    componentDidMount(): void {
        this.props.getPhaseConfigList();
    }

    componentWillUnmount(): void {
        this.props.destroyDetailsDrawer();
        this.props.setFiltersDrawerVisibility(false);
        this.props.setJobTestType(false);
    }

    /**
     * On tab change event, set store's current active test type
     * this allows us to keep track of type of loaded test list
     * @param {string} currentTabType
     */
    onChangeHandler(currentTabType: string): void {
        switch (currentTabType) {
            case ContentType.AVAILABLE:
                this.props.setFilterType(FilterType.CLAIMABLE);
                break;
            case ContentType.IN_PROGRESS:
                this.props.setFilterType(FilterType.ONGOING);
                break;
            case ContentType.COMPLETED:
                this.props.setFilterType(FilterType.DONE);
                break;
            default:
                break;
        }
        this.props.setActiveTestType(currentTabType);
        this.props.setSelectedFilters({
            skills: [],
            types: [],
            statuses: [],
            decoratedStatuses: [],
        });
    }

    /**
     * Generate tab panes for each of contentType enum members, excluding first element "FEATURED"
     * @return {React.ReactElement[]}
     */
    getTabPanes(): React.ReactElement[] {
        const {isMobile, activeTestType}: Props = this.props;
        return Object.keys(ContentType).map((testType: string): React.ReactElement => (
            <TabPane
                tab={<Translate id={`${QualificationsView.translationPath}.${testType}_TAB.text`}/>}
                key={testType}
            >
                {activeTestType === testType && (
                    <CardList isMobile={isMobile} key={activeTestType} isTest/>
                )}
            </TabPane>
        ));
    }

    render(): React.ReactElement<HTMLDivElement> {
        const {isMobile, activeTestType, translate}: Props = this.props;
        const tabPosition: TabPosition = isMobile ? "top" : "left";
        const tabType: TabsType = isMobile ? "line" : "card";

        return (
            <div className="df-qualifications-container">
                <Tabs
                    tabPosition={tabPosition}
                    type={tabType}
                    onChange={this.onChangeHandler}
                    activeKey={activeTestType}
                    moreIcon={(
                        <span aria-label={translate(`${QualificationsView.translationPath}.moreTabs.text`) as string}>
                            <Translate id={`${QualificationsView.translationPath}.moreTabsContent.text`}/>
                        </span>
                    )}
                >
                    {this.getTabPanes()}
                </Tabs>
            </div>
        );
    }
}

function mapStateToProps(state: StoreState): StateProps {
    return {
        translate: getTranslate(state.localize),
        isMobile: state.mobile.isMobile,
        activeTestType: state.test.activeTestType,
    };
}

const mapDispatchToProps: DispatchProps = {
    setActiveTestType,
    setFilterType,
    getPhaseConfigList,
    setSelectedFilters,
    destroyDetailsDrawer,
    setFiltersDrawerVisibility,
    setJobTestType,
};

export default connect(mapStateToProps, mapDispatchToProps)(QualificationsView);
